import { Space, Switch, SwitchProps } from 'antd';
import { omit } from 'lodash';
import React from 'react';
import { useInputController } from '../hooks/useInputController';
import { IsBooleanCheckboxElementSymbol } from '../item/symbols/isBooleanCheckboxElement';
import { useFormItemAccessibility } from '../item/useFormItemAccessibility';
import { useFormItemEnabled } from '../item/useFormItemEnabled';

export interface ISwitchInputProps extends Omit<SwitchProps, 'name'> {
  name: string;
  /**
   * Aggungiamo proprietà readOnly non gestita da antd
   * solo per compatibilita per il passaggio della proprietà
   * ma non è gestito il comportamento
   */
  readOnly?: boolean;

  children?: React.ReactNode;
}

export function SwitchInput(props: ISwitchInputProps) {
  const { name, children, ...inputProps } = props;

  const { enabled, layoutEnabled } = useFormItemEnabled();

  const { field } = useInputController(name, { enabled });

  const accessibility = useFormItemAccessibility();

  const switchNode = (
    <Switch
      disabled={enabled === false || layoutEnabled === false}
      {...inputProps}
      {...field}
      // Gli Switch non supportano aria-required, in quanto non esiste un valore "indeterminato"
      {...omit(accessibility.attributes, ['aria-required'])}
      checked={field.value}
      aria-checked={field.value}
      // checkedChildren={inputProps.checkedChildren ?? 'Sì'}
      // unCheckedChildren={inputProps.unCheckedChildren ?? 'No'}
    />
  );

  return children ? (
    <Space>
      {switchNode}
      {children}
    </Space>
  ) : (
    switchNode
  );
}

SwitchInput[IsBooleanCheckboxElementSymbol] = true;
